import {createReducer} from "typesafe-actions";
import {getPlayerSettings, savePlayerSettingsAsync} from "../actions";
import {SettingsModel} from "../../../models/api/codegen/code";

const INITIAL_PLAYER_SETTINGS: SettingsModel = {
    acceptType: "DO_NOT_ACCEPT_CHANGES",
    theme: 'darkTheme',
    defaultLine: undefined,
    defaultLive: undefined,
    needConfirm: false,
};

export const playerSettings = createReducer<SettingsModel>(INITIAL_PLAYER_SETTINGS)
    .handleAction(getPlayerSettings.success,
        (state: SettingsModel, action: {payload: SettingsModel}) => action.payload)
    .handleAction(savePlayerSettingsAsync.success,
        (state: SettingsModel, action: {payload: SettingsModel}) => action.payload);

export const isLoadingSettings = createReducer(false)
    .handleAction(getPlayerSettings.request, () => true)
    .handleAction(getPlayerSettings.success, () => true);